(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition();

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.facebookAdDeliveryStatuses = definition();

    }

    function definition() {

        return {
            ACTIVE: {
                id: 'ACTIVE',
                name: 'Active',
                deliveryInfos: ['active', 'limited']
            },
            SCHEDULED: {
                id: 'SCHEDULED',
                name: 'Scheduled',
                deliveryInfos: ['scheduled']
            },
            PENDING_REVIEW: {
                id: 'PENDING_REVIEW',
                name: 'Pending Review',
                deliveryInfos: ['pending_review']
            },
            NOT_APPROVED: {
                id: 'NOT_APPROVED',
                name: 'Not Approved',
                deliveryInfos: ['recently_rejected', 'rejected']
            },
            INACTIVE: {
                id: 'INACTIVE',
                name: 'Inactive',
                deliveryInfos: ['inactive']
            },
            NOT_DELIVERING: {
                id: 'NOT_DELIVERING',
                name: 'Not Delivering',
                deliveryInfos: ['not_delivering', 'not_published', 'rejected']
            },
            COMPLETED: {
                id: 'COMPLETED',
                name: 'Completed',
                deliveryInfos: ['completed', 'recently_completed']
            },
            DELETED: {
                id: 'DELETED',
                name: 'Deleted',
                deliveryInfos: ['archived', 'permanently_deleted']
            }
        };
    }
})();
